import React, { useContext, useEffect } from 'react';
import { Flex, Form, Input, Select, message } from 'antd';
import { ContextStatus } from '@leedpulse-monorepo/enums';
import DomainCreationFormContext from '../../contexts/forms/domains/DomainCreationFormContext';
import { FormCard, FormContainer, FormSectionTitle } from '@leedpulse-monorepo/components';
import { DOMAINS_PAGE_PATH } from '../../pages/domains/DomainsPage';
import { handleErrorInputMessage, handleInputError } from '../../../core/utils/errorUtils';
import { useNavigate } from 'react-router-dom';
import { InfoCircleOutlined } from '@ant-design/icons';

const DomainCreationForm: React.FC = () => {
  const navigate = useNavigate();
  const formContext = useContext(DomainCreationFormContext);

  useEffect(() => {
    switch (formContext.status) {
      case ContextStatus.SUCCESS:
        message.success('Domaine créé avec succès');
        navigate(DOMAINS_PAGE_PATH);
        break;
      case ContextStatus.ERROR:
        message.error('Erreur lors de la création du domaine');
        break;
      default:
        break;
    }
  }, [formContext.status, navigate]);

  return (
    <FormCard
      title="Nouveau Domaine"
      showTitle={false}
      onCreated={() => formContext.submit()}
      isCreateLoading={formContext.status === ContextStatus.LOADING}
      isOnError={formContext.name === ''}
    >
      <Form layout="vertical">
        <FormSectionTitle title={<Flex align="center"><InfoCircleOutlined style={{ marginRight: 6 }} /> Informations générales</Flex>} />
        <FormContainer>
          <Form.Item
            label="Nom"
            validateStatus={
              handleInputError(formContext.name, formContext.status)
            }
            help={
              handleErrorInputMessage(formContext.name, formContext.status)
            }>
            <Input
              placeholder='Immobilier'
              value={formContext.name}
              onChange={(e) => formContext.onNameChange(e.target.value)}
            />
          </Form.Item>
          <Form.Item label="Tags">
            <Select
              mode="tags"
              value={formContext.tags}
              onChange={(value) => formContext.onTagsChange(value)}
              style={{ width: '100%' }}
            />
          </Form.Item>
          <Form.Item 
          label="Description">
            <Input.TextArea
              showCount
              maxLength={500}
              placeholder="L'immobilier englobe toutes les activités liées à l'achat, la vente, la location et la gestion de biens immobiliers, ..."
              value={formContext.description}
              rows={4}
              onChange={(e) => formContext.onDescriptionChange(e.target.value)}
            />
          </Form.Item>
        </FormContainer>
      </Form>
    </FormCard>
  );
};

export default DomainCreationForm;
